import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const note = async (id?: number) => axios.get(Routes.NOTE + "/" + id);

export const useNote = (id?: number) =>
  useQuery({
    queryKey: [Keys.NOTE_QRY, id],
    queryFn: () => note(id),
    enabled: id ? true : false,
  });
